import React, {useEffect} from 'react'

import useCanonical from '~/hooks/useCanonical'
import VerifyEmailMutation from '~/mutations/VerifyEmailMutation'
import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import Ellipsis from './Ellipsis/Ellipsis'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'
import PrimaryButton from './PrimaryButton'
import TeamInvitationWrapper from './TeamInvitationWrapper'




const VerifyEmail = (props) => {
  const {history, match} = props
  const {params} = match
  const {verificationToken, invitationToken} = params
  const atmosphere = useAtmosphere()
  const {onCompleted, onError, error, submitMutation} = useMutationProps()
  useCanonical('verify-email')
  useEffect(() => {
    submitMutation()
    VerifyEmailMutation(
      atmosphere,
      {verificationToken, invitationToken: invitationToken || '', isInvitation: !!invitationToken},
      {onCompleted, onError, history}
    )
  }, [])
  return (
    React.createElement(TeamInvitationWrapper, null
      , React.createElement(InviteDialog, null
        , React.createElement(DialogTitle, null, "Email Verification" )
        , React.createElement(DialogContent, null
          , React.createElement(InvitationDialogCopy, null, error ? error.message : 'You’re almost in!')
          , React.createElement(InvitationCenteredCopy, null
            , !error && (
              React.createElement(PrimaryButton, { size: "medium", waiting: true,}
                , React.createElement('span', null, "Verifying now" )
                , React.createElement(Ellipsis, null )
              )
            )
          )
        )
      )
    )
  )
}

export default VerifyEmail
